import { createStore } from 'vuex'

export default createStore({
  state: {
    product_nav: 'product',
    join_nav: 'merchantJoin',
    scroll_top: 0,
  },
  getters: {},
  mutations: {
    switchProductNav(state, nav) {
      state.product_nav = nav;
    },
    switchJoinNav(state, nav) {
      state.join_nav = nav
    },
    scrollTop(state, n) {
      state.scroll_top = n;
    }
  },
  actions: {},
  modules: {}
})